// extracted by mini-css-extract-plugin
export default {"buttonWrap":"DownloadButton_buttonWrap__V+72x","button":"DownloadButton_button__ZKOgC"};